import { clsx } from 'clsx';
import { IProps } from './HeroDonationBlock.interface';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
  ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import { DonationWidget } from '../DonationBlock/DonationBlock.component';
import Heading from '@/elements/Heading/Heading.component';
import Text from '@/elements/Text/Text.component';
import Button from '@/elements/Button/Button.component';
import './HeroDonationButtons.styles.css'

export const HeroDonationBlock = (props: IProps) => {

  const { title, description, buttons, donateform, ...rest } = props;


  return (
    <BlockWrapper className="heroDonationBlock" {...rest} layout='hero'>
      <ContentWrapper>
        <ContentColumn className="heroDonationBlock__content">
          {title && <Heading level={1} className="heroDonationBlock__title" html={title} />}
          {description && <Text className="heroDonationBlock__description" html={description} />}
          {buttons && buttons.map((button, index) => (
            <Button
              key={`hero-donation-block-button-${index}`}
              {...button}
              className={clsx('heroDonationBlock__button', button.className)}
            />
          ))}
        </ContentColumn>
        <ContentColumn>
          <DonationWidget {...donateform} formName='heroDonation' />
        </ContentColumn>
      </ContentWrapper>
    </BlockWrapper>
  );
};
